<script>
import { runsheetMethods } from '@state/helpers'
import moment from "moment"
import Loading from "@components/loading"

export default {
  $_veeValidate: {
    validator: 'new',
  },
  components: { Loading },
  props: ['visible', 'runsheet'],
  data() {
    return {
      loading: true,
      sourceRunsheet: null,
      runsheetSelectOptions: [],
      selectedRunsheetIds: []
    }
  },
  watch: {
    visible: function() {
      if (this.visible) {
        this.setupForm()
      }
    }
  },
  methods: {
    ...runsheetMethods,
    
    async setupForm() {
      this.loading = true
      this.sourceRunsheet = null
      this.runsheetSelectOptions = []
      this.selectedRunsheetIds = []

      let date = moment(this.runsheet.dateSeconds).format('YYYY-MM-DD')
      const response = await this.getRunsheetsByDate({date: date})

      for (const runsheet of response) {
        if (runsheet.id === this.runsheet.id) {
          this.sourceRunsheet = { ...runsheet }
        } else {
          this.runsheetSelectOptions.push({
            value: runsheet.id,
            text: `${runsheet.id} - ${runsheet.route.name} - ${runsheet.vehicle.number_plate}`
          })
        }
      }
      this.loading = false

      if (this.sourceRunsheet === null) {
        console.error("Unable to find source runsheet... Weird..")
        this.close()
      }
    },
    async submit() {

      const valid = await this.$validator.validateAll()
      
      if (valid) {
        this.$emit('submit', this.selectedRunsheetIds.map(item => parseInt(item)))
      }
    },
    close() {
      this.$validator.reset()
      this.$emit('close')
    },
  }
}
</script>
<template>
  <!-- Update Route MODAL -->
  <VLayout
    row
    justify-center
  >
    <Loading :display="visible && loading" />
    <VDialog
      v-if="sourceRunsheet != null"
      v-model="visible"
      persistent
      max-width="500px"
      scrollable
    >
      <VCard>
        <VContainer grid-list-md>
          <h2>Reassign Runsheet Collections</h2>
          <p>Move all collections from {{ sourceRunsheet.route.name }} to one or more other runsheets.</p>
          <p>If more than one target runsheet is selected, the collections will be distributed evenly to each runsheet.</p>
          <p><b>Use with caution.</b> This function will place collections in the target runsheets regardless of their service or waste types.</p>
          <VLayout wrap>

            <VFlex
              xs12
              sm12
            >
              <VSelect
                v-model="selectedRunsheetIds"
                v-validate="'required'"
                :items="runsheetSelectOptions"
                required
                :error-messages="errors.collect('target runsheets')"
                data-vv-name="target runsheets"
                label="Target Runsheets"
                :menu-props="{ absolute: true }"
                multiple
                chips
                attach
              />
            </VFlex>

            <VSpacer />

            <VFlex
              xs12
              sm6
              md6
            >
              <VBtn
                color="blue"
                block
                outline
                @click.native="close()"
              >
                Close
              </VBtn>
            </VFlex>
            <VFlex
              xs12
              sm6
              md6
            >
              <VBtn
                color="blue"
                block
                @click.native="submit()"
              >
                Save
              </VBtn>
            </VFlex>
          </VLayout>
        </VContainer>
      </VCard>
    </VDialog>
  </VLayout>
</template>